import { t } from '@lingui/core/macro';

/** Title of the summary step, shared by the mobile, stationary and proposal flows. */
export const getBookingSummaryTitle = () => t`Does this look correct?`;
